import {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T220554-home-page-seo-navbar-webapp-v1': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'T228056-webapp-search': 'test',
  'T233261-webapp-user-search-v2': 'test',
  'T214387-freelancer-suggested-milestones': 'control',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T58186-giveget-delayed-payment-verify-v2': 'control',
  'T90189-image-thumbnail-service': 'control',
  'T178308-freelancer-my-projects-empty-state-V2': 'control',
  'T194666-hourly-initial-payment': 'control',
  'T211099-webapp-user-search': 'control',
  'T228646-browse-callout-revamp': 'control',
  'T221621-fixed-initial-payment-v3': 'control',
  webapp_playground_test: 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
